import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Verify from '../views/Verify.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/verify',
    name: 'Verify',
    component: Verify,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
